import { Alert, Autocomplete, Box, Button, Card, Table, Typography } from '@mui/joy'
import React, { useEffect, useState } from 'react'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { post, Token } from '../../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
function Verantwortlichetarif({ data, updates }) {
  const [user, setuser] = useState();
  const navigate = useNavigate();
  const [create, setcreate] = useState(false);
  const [selecteduser, setselecteduser] = useState();
  const [bearbeitungsrechte, setbearbeitungsrechte] = useState([{ val: true, title: "Ja, Bearbeitungsrechte erteilen" }, { val: false, title: "Nein, Bearbeitungsrechte nicht erteilen" }])
  const [selectedop, setselectedop] = useState();
  const [alert, setalert] = useState(false);
  useEffect(() => {
    const fetchVereinData = async () => {
      const body = {
        token: Token.get(),
        action: "get_users",
        target: data.subkath,
      };

      try {
        let response = await post(body, "/vergleiche/sub-sparten");
        if (response === "LOGOUT") {
          navigate("/");
          return;
        }
        setuser(JSON.parse(response).users);
        console.log(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    setTimeout(()=> {
    fetchVereinData();
    }, 15)
    

  }, []);
  function add() {
    let body = {};
    body.targetuser = selecteduser.id;
    body.token = Token.get();
    body.action = "add_verantwortlichen";
    body.targetid = data.id;
    body.editrights = selectedop;
    let response = post(body, "/tarife/edit_tarif");
    if (response == "LOGOUT") {
      navigate("/");
    }
    if (response == "OK") {
      updates();
      setcreate(false);
      setalert(true);
    }
  }
  function del() {

  }


  return (
    <>
      {
        alert && (
          <Alert
            sx={{ mb: 5 }}
            variant="soft"
            color="success"
            startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
            endDecorator={
              <Button size="sm" variant="solid" color="success" onClick={() => setalert(false)}>
                Schliesen
              </Button>
            }
          >
            Ihre änderungen wurden Erfolgreich gespeichert.
          </Alert>
        )
      }
      {
        create && (
          <Card variant='soft' sx={{ mb: 2 }}>
            <Typography level="title-md">Verantwortlichen hinzufügen</Typography>
            <Typography>Nutzer wählen</Typography>
            <Autocomplete
              options={user}
              placeholder='Max Mustermann'
              sx={{ width: "25%" }}
              getOptionLabel={(option) => option.name}
              onChange={(e, newValue) => setselecteduser(newValue)}
            />
            <Typography>Bearbeitungsrechte setzen</Typography>
            <Autocomplete
              options={bearbeitungsrechte}
              placeholder='Bearbeitungsrechte ?'
              sx={{ width: "25%" }}
              getOptionLabel={(option) => option.title}
              onChange={(e, newValue) => setselectedop(newValue.val)}
            />
            <Button sx={{ width: "15%", height: "5%" }} onClick={
              () => add()
            }>Hinzufügen</Button>
          </Card>
        )
      }

      <Card variant='soft'>
        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
          <Box>
            <Typography level="title-md">Verantwortliche</Typography>
          </Box>
          {
            data && data.editperms && (
              <Button sx={{ width: "15%" }} onClick={() => setcreate(true)}>Verantwortlichen hinzufügen</Button>
            )
          }

        </Box>
        <Table>
          <thead>
            <th>Nutzer</th>
            <th>Bearbeitungsrechte</th>
            {
              data && data.editperms && (
                <th>Bearbeiten</th>
              )
            }
          </thead>
          <tbody>
            {data && data.Verantwortliche && data.Verantwortliche.map((item) => {

              return (
                <tr key={item.id}>
                  <td>
                    {item.name}
                  </td>
                  <td>
                    {item.editrights ? "Ja" : "Nein"}
                  </td>
                  {
                    data && data.editperms && (
                      <td>
                        <Button
                          variant="soft"
                          color="danger"
                          startDecorator={<DeleteForeverOutlinedIcon />}

                        >
                          Löschen
                        </Button>
                      </td>
                    )
                  }
                </tr>

              );
            })
            }


          </tbody>

        </Table>
      </Card>
    </>
  )
}

export default Verantwortlichetarif
